import { api, ApiResponse, authHeader } from '@you-go-vn/components';
import { SellingSchedule, SellingScheduleResponse } from './data';

const defaultPathApi = (restaurantId: number) =>
  `/api/restaurants/${restaurantId}/sale-schedule`;

const add = async (restaurantId: number, body: SellingSchedule) => {
  return api.post<ApiResponse<SellingSchedule>>(defaultPathApi(restaurantId), body, {
    headers: authHeader(),
  });
};

const list = async (restaurantId: number) => {  
  return api.get<ApiResponse<SellingScheduleResponse[]>>(defaultPathApi(restaurantId), {
    headers: authHeader(),
  });
};

const getById = async (restaurantId: number, scheduleId: number) => {
  return api.get<ApiResponse<SellingScheduleResponse>>(`${defaultPathApi(restaurantId)}/${scheduleId}`, {
    headers: authHeader(),
  });
};

const update = async (restaurantId: number, scheduleId: number, body: SellingSchedule) => { 
  return api.put<ApiResponse<SellingSchedule>>(`${defaultPathApi(restaurantId)}/${scheduleId}`, body, {
    headers: authHeader(),
  });
};

export const sellingScheduleService = {
  add,
  list,
  getById,
  update,
};
